import { render, staticRenderFns } from "./HabilityList.vue?vue&type=template&id=0adaa3e2"
import script from "./HabilityList.vue?vue&type=script&lang=js"
export * from "./HabilityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports